import { render, staticRenderFns } from "./RoleRightPage.vue?vue&type=template&id=f1ff6f24&scoped=true&"
import script from "./RoleRightPage.vue?vue&type=script&lang=js&"
export * from "./RoleRightPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ff6f24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1ff6f24')) {
      api.createRecord('f1ff6f24', component.options)
    } else {
      api.reload('f1ff6f24', component.options)
    }
    module.hot.accept("./RoleRightPage.vue?vue&type=template&id=f1ff6f24&scoped=true&", function () {
      api.rerender('f1ff6f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/RoleRightPage.vue"
export default component.exports